export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const backgroundImage = require("../assets/background.png");
export const sidearrow = require("../assets/89e645e37c1e20f25803c3025ede7af8892b24ce.png");
export const userIcon = require("../../dashboard/assets/userIcon.png");